import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import { fetchResponse } from './actions'
import { createNamespacedReducer, createNamespacedSelector } from '../namespaces'

const fetched = handleActions({
  [fetchResponse]: createNamespacedReducer((state, action) => {
    if (action.error) {
      console.error(action.payload)
      return null
    }

    return action.payload
  })
}, {})

export default combineReducers({
  fetched,
})

export * from './actions'
export const createFetchedSelector = createNamespacedSelector(state => state.nautilusApi.fetched)
